import { IProductSearchResponse } from '../../models/product-list';
import { IErrorResult, IResult } from '../../models/result-models';
import {
    LOAD_PRODUCTS_ERROR,
    LOAD_PRODUCTS_SUCCESS,
} from './product-list-actions';

interface ILoadProductsSuccessAction {
    type: 'LOAD_PRODUCTS_SUCCESS';
    payload: IResult<IProductSearchResponse>;
}

interface ILoadProductsErrorAction {
    type: 'LOAD_PRODUCTS_ERROR';
    payload: IErrorResult;
}

type KnownAction = ILoadProductsSuccessAction | ILoadProductsErrorAction;

export const productsReducer = (
    state: IResult<IProductSearchResponse> | null | undefined = null,
    action: KnownAction
) => {
    switch (action.type) {
        case LOAD_PRODUCTS_SUCCESS:
            return action.payload;
        case LOAD_PRODUCTS_ERROR:
            return {
                ok: false,
                data: state!.data,
                errors: action.payload.modelErrors,
                message: action.payload.errorMessage,
            };
        default:
            return state;
    }
};
